const request = {}

request.createRequest = function (params) {
  return {
    orderList: params.orderList,
    paymentDate: params.date,
    paymentMethodId: params.method.value
  }
}
export default { request }
